import { Box, Typography } from "@mui/material";


interface BizLogoProps {
  fontSize?: number;
}

export const BizLogo: React.FC<BizLogoProps> = ({ fontSize }) => {

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      
        m: 0,
        p: 0,
      }}
    >
      <Typography
        sx={{
          fontSize: `${fontSize}px`,
          fontWeight: 700,
          color: "secondary.main",
          m: 0,
          p: 0,
          lineHeight: 1,
          letterSpacing: 0,
        }}
      >
        Biz
      </Typography>
    </Box>
  );
};
